import React from 'react';

export default function ProfitabilityReport({ user }) {
  return (
    <div style={{ 
      padding: 8, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px'
    }}>
      <div style={{
        fontSize: '18px',
        color: '#666',
        padding: '40px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        maxWidth: '500px'
      }}>
        טרם אופיין דוח
      </div>
    </div>
  );
}
